import {Directive, ElementRef, NgModule, AfterViewInit, Input} from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit{

    constructor(private host: ElementRef) {}
    @Input() focus: boolean = true;
    ngAfterViewInit() {

        // note that if the host is not a native focusable element (such as button, input, link),
        // then a tabindex=-1 should be added manually to that host
        if(this.focus) {
            this.host.nativeElement.focus();
        }
    }
}



@NgModule({
    declarations: [AutofocusDirective],
    exports: [AutofocusDirective]
})
export class AutofocusDirectiveModule {}
